import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=779767b8&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=js&"
export * from "./DefaultButton.vue?vue&type=script&lang=js&"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=779767b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779767b8",
  null
  
)

export default component.exports